import { render, staticRenderFns } from "./driverReferralCode.vue?vue&type=template&id=18f0d27f&scoped=true"
import script from "./driverReferralCode.vue?vue&type=script&lang=js"
export * from "./driverReferralCode.vue?vue&type=script&lang=js"
import style0 from "./driverReferralCode.vue?vue&type=style&index=0&id=18f0d27f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0d27f",
  null
  
)

export default component.exports